// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"3bef4cb2","816":"71294a5e","977":"240addac"}[chunkId] + ".chunk.js";
};